import {
  Component,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import deepmerge from 'deepmerge';
import * as echarts from 'echarts';
import { combineMerge } from '../bar-chart/bar-chart.component';

const colors = ['#007BFF', '#0067D6', '#004DB7', '#003598', '#001F7A', '#01154F'];

@Component({
  selector: 'app-donut-chart',
  templateUrl: './donut-chart.component.html',
  styleUrls: ['./donut-chart.component.scss'],
})
export class DonutChartComponent implements OnInit, OnDestroy, OnChanges {
  @Input() loading = true;
  @Input() series: { name: string; data: number[] };
  @Input() translateLabels: boolean = false;
  @Input() options: echarts.EChartsOption = {};

  chartOption: echarts.EChartsOption;
  chartInstance: echarts.ECharts | null = null;

  isLoading = true;

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (this.chartInstance) {
      this.chartInstance.resize();
    }
  }

  constructor(private translateService: TranslateService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.updateChartOptions();

    if (changes['loading']) {
      setTimeout(() => {
        this.isLoading = this.loading;
      }, 333);
    }
  }

  ngOnInit(): void {
    this.updateChartOptions();
  }

  updateChartOptions() {
    const options = {
      title: {
        show: false,
      },
      tooltip: {
        trigger: 'item',
      },
      legend: {
        bottom: '0%',
        left: 'center',
      },
      series: {
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 10,
          borderColor: '#fff',
          borderWidth: 2,
        },

        data: this.series?.data?.map((data: any, index) => {
          return {
            ...data,
            name: this.translateLabels
              ? this.translateService.instant(`charts.labels.${data.name}`)
              : data.name,
          };
        }),
      },
    };

    this.chartOption = deepmerge(options, this.options, {
      arrayMerge: combineMerge,
    });
  }

  ngOnDestroy(): void {}

  onChartInit(ec: any) {
    this.chartInstance = ec;
  }
}
